export class DigilockerAuthResponse{
  access_token: string;
  expires_in: number;
  token_type: string;
  scope: string;
  consent_valid_till: string;
  digilockerid: string;
  name: string;
  dob: string;
  gender: string;
  eaadhaar: string;
  reference_key: string;
  mobile: string;
  refresh_token: string;
  new_account: string;
}
